var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home-layout"}},[_vm._t("default"),_c('Alert',{attrs:{"snackbar":_vm.snackbar,"type":_vm.alertType,"text":_vm.alertText},on:{"close":_vm.onCloseAlert}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }